import styled from 'styled-components';

export const ContactListStyle = styled.ul`
    padding: 0px;
    border: 1px solid #31d37a;
    width: 422px;
`